import { render, staticRenderFns } from "./ChooseTopicOriginForm.vue?vue&type=template&id=e3d2395e&scoped=true"
import script from "./ChooseTopicOriginForm.vue?vue&type=script&lang=js"
export * from "./ChooseTopicOriginForm.vue?vue&type=script&lang=js"
import style0 from "./ChooseTopicOriginForm.vue?vue&type=style&index=0&id=e3d2395e&prod&lang=scss&scoped=true"
import style1 from "./ChooseTopicOriginForm.vue?vue&type=style&index=1&id=e3d2395e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d2395e",
  null
  
)

export default component.exports